// extracted by mini-css-extract-plugin
export default {"home":"home__V5Od3","h1":"h1__8dAOq"};